/* eslint-disable */
import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { RampPgApiSdk } from '~api/RampPgApiSdk';
import {
    DATA_BEHAVIOUR,
    DATA_VULCAN_CONFIG,
    LOW_ENV_TOKEN,
    PROD_TOKEN
} from '~constants/Constants';
import { IVulcanConfig } from '~domain/entities/Config';
import { ConfigRepository } from '~repositories/ConfigRepository';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';

import { getActionName } from 'src/vulcan/common';
import {
    addListeners,
    bindUsingDOM,
    getNodeByAttributeValue,
    TExportExternal
} from './ExternalReference';

export function ExportExternal<T>(props: TExportExternal<T>) {
    const { componentName, Component: _Component, onBind } = props;
    const bindEventName = getActionName.bind(componentName);
    const boundEventName = getActionName.bound(componentName);
    const readyEventName = getActionName.ready(componentName);

    const _onBind = (event: CustomEvent) => {
        const Component = _Component;

        const {
            detail: { rootNode, config, translations, hasLoyalty },
            detail
        } = event;

        onBind?.(event);

        initConfigs(config, hasLoyalty);
        initApiSdk(componentName);
        ReactDOM.render(<Component config={config} translations={translations} />, rootNode);
        dispatchEvent(new CustomEvent(boundEventName, { detail }));
    };

    bindUsingDOM({
        attribute: DATA_BEHAVIOUR,
        attributeValue: componentName,
        externalProps: props
    });

    addListeners({ eventName: bindEventName, listener: _onBind });
    dispatchEvent(new CustomEvent(readyEventName, { detail: { componentName } }));
}

const initConfigs = (config: any, hasLoyalty: boolean) => {
    const { setConfigs, setIamType, setHasLoyalty } = diContainer.get(
        serviceNames.configRepository
    ) as ConfigRepository;

    setConfigs(config || {});
    setHasLoyalty(hasLoyalty);
    setIamType(window.location.pathname.replace('/', ''));
};

function initApiSdk(componentName: string) {
    const rampPgApiSdk = diContainer.get(serviceNames.rampPgApiSdk) as RampPgApiSdk;
    const rootNode = getNodeByAttributeValue(DATA_BEHAVIOUR, componentName);
    const vulcanConfigs = rootNode?.getAttribute(DATA_VULCAN_CONFIG) || '{}';
    const {
        env = '',
        perlgem: { regionId = 0, brandId = 0 } = {},
        stardust: { buid = '' } = {}
    } = JSON.parse(vulcanConfigs) as IVulcanConfig;

    rampPgApiSdk.setup({
        regionId,
        brandId,
        token: env === 'dev' ? LOW_ENV_TOKEN : PROD_TOKEN,
        baseUrl: window.location.origin,
        businessUnitId: buid
    });
}
